import axiosInstance from '../utils/axiosInstance';
import type { Matter, MatterStatus } from '../../types/matter';

interface ListMattersResponse {
  success: boolean;
  data: { matters: Matter[] };
}

export const listMatters = async (status?: MatterStatus): Promise<Matter[]> => {
  const params = status ? { status } : undefined;
  const response = await axiosInstance.get<ListMattersResponse>('/matters/list', { params });
  return response.data.data.matters;
};
